import { yupArray } from 'services/yup/custom-schemas/array'
import { upsellingVSBuilder } from './upselling'
import { YupSchema } from 'services/yup'
import { FoodUpselling } from 'services/api/entities/catalog/foodUpselling/types/internal/foodUpselling-models'

export const foodUpsellingVS: YupSchema<FoodUpselling> = upsellingVSBuilder(
  'foodsupselling'
).shape({
  logistics: yupArray().min(1),
  logisticsFull: yupArray(),
})
